import request from '@/utils/request'

const siteIntegralDetails = {
  name: 'siteIntegralDetails',
  state: {
    isSiteIntegralDetailsDetailLoading: false,
    siteIntegralDetailsDetailData: {}
  },

  mutations: {
    SET_IS_MODULE_SITEINTEGRAL_DETAIL_LOADING: (state, data) => {
      state.isSiteIntegralDetailsDetailLoading = data
    },
    SET_MODULE_SITEINTEGRAL_DETAIL_DATA: (state, data) => {
      state.siteIntegralDetailsDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    querySiteIntegralDetailsDetailData({ commit }, id) {
      commit('SET_IS_MODULE_SITEINTEGRAL_DETAIL_LOADING', true)
      commit('SET_MODULE_SITEINTEGRAL_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/siteIntegralDetails/siteIntegralDetailsDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULE_SITEINTEGRAL_DETAIL_LOADING', false)
          commit('SET_MODULE_SITEINTEGRAL_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULE_SITEINTEGRAL_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetSiteIntegralDetailsDetailData({ commit }) {
      commit('SET_MODULE_SITEINTEGRAL_DETAIL_DATA', {})
    },
    //  重置账号新增页面数据
    setSiteIntegralDetailsDetailData({ commit }, data) {
      commit('SET_MODULE_SITEINTEGRAL_DETAIL_DATA', data)
    }
  }
}

export default siteIntegralDetails
